export default __webpack_public_path__ + "static/media/customer_access_white_background.b86fcad6.svg";